import './Mission.css'
import MissionContent from './MissionContent';
import community_img from '../about_assets/community.svg';
import influence_img from '../about_assets/influence.svg';
import giving_img from '../about_assets//givingBack.svg';
import { useState, useEffect } from 'react';

const Mission = () => {
    const missionContents = [
        [
            community_img,
            'Community',
            'We believe that the community is larger and wiser than disconnected individuals. We will share, connect and inspire the community to join forces and make a greater impact through the SVLC platform.'
        ],
        [
            influence_img,
            'Influence',
            'We strive for noble pursuits and will cultivate the necessary skills to enable SVLC members to increase their sphere of influence; thereby, to elevate American Chinese leaders at large.'
        ],
        [
            giving_img,
            'Giving Back',
            'We believe the future is worth investing. As we connect and elevate each other within SVLC, we are committed to give back and nurture younger generations through coaching and mentoring.'
        ]
    ];

    const [selectedIndex, setSelectedIndex] = useState(1);

    const handleClick = (index) => {
        setSelectedIndex(index);
    };


    const missions = missionContents.map((content, index) => (
        <MissionContent
            className = {'mission_card_container_select' }
            key = {index}
            imageURL = {content[0]}
            title = {content[1]}
            content = {content[2]}
            onClick = {() => handleClick(index)}
        />
    ));

    return (
        <div className='mission_background'>
            <div className='mission_container'>
                <h1>Our Vision</h1>
                {/*<hr className='hr1'/>*/}
                {/* <p>Foster community and opportunities for world-class leaders in technology.</p> */}
                <p>To be the leading community for Asian American leaders in Silicon Valley, where every member is empowered to reach his or her full potential. </p>
                <hr className='hr2'/>
                <h3>Our Mission</h3>
                <p className='mission-content'>To empower and connect Asian American leaders by enhancing leadership skills, forging deep relationships, broadening networks across industry and function, and fostering a collaborative community that champions diversity, innovation, and excellence.</p>
                {/*<hr className='hr1'/>*/}
                {/* <div className='mission_cards_container'>
                    {missions}
                </div> */}
                {/*<hr className='hr2'/>*/}
                {/*<h1>Our Vision</h1>*/}
                {/*<hr className='hr1'/>*/}
                {/*<p>Foster community and opportunities for world-class leaders in technology.</p>*/}
            </div>
        </div>
    )
}

export default Mission;
